module.exports = __webpack_public_path__ + "img/1970East-004_WEB-min.da336883.jpg";